module.exports = __webpack_public_path__ + "static/media/users-class.3bd683d4.svg";